<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <div class="medical-detail-cntainer">
        <TopBg title="培训认证" sub-title="聚焦AI智能体应用交付与AIIT服务管理，培养懂业务、会配置、能交付、可优化、可运维的AI应用型人才。" :bg="topBg" />
        <transition v-if="!isMobile" name="fade">
            <div class="localRow nav-row" v-show="showRow">
                <div class="nav-item" :class="{ active: activeSection === 'partners' }"
                    @click="scrollToSection('partners')">认证体系</div>
                <div class="nav-item" :class="{ active: activeSection === 'audience' }"
                    @click="scrollToSection('audience')">面向人群</div>
                <div class="nav-item" :class="{ active: activeSection === 'value' }" @click="scrollToSection('value')">
                    认证价值</div>
                <div class="nav-item" :class="{ active: activeSection === 'process' }"
                    @click="scrollToSection('process')">认证流程</div>
                <!-- <div class="nav-item" :class="{ active: activeSection === 'content' }" @click="scrollToSection('content')">认证内容</div> -->
                <div class="nav-item" :class="{ active: activeSection === 'query' }" @click="scrollToSection('query')">
                    证书查询</div>
                <!-- <div class="nav-item" :class="{ active: activeSection === 'agency' }"
                    @click="scrollToSection('agency')">考试授权机构</div> -->
            </div>
        </transition>
        <div class="main-content page">
            <div class="section">
                <div class="title">认证概述</div>
                <div class="disc">
                    智先生Al培训认证体系面向医疗、政企、信息化与数字化服务场景，围绕AI智能体应用建设、业务流程优化、知识库配置、工具调用、项目交付与持续运营等关键能力，提供“课程学习+案例实训+结业考核+证书认证”的一体化培养路径。<br />
                    认证体系以真实业务场景为牵引，重点培养能够理解客户需求、拆解应用场景、配置AI应用、完成交付上线并持续优化效果的复合型人才，帮助组织建立可复用、可持续发展的Al应用交付培训体系。<br />
                    该体系顺应数字技术人才培养和人工智能工程技术应用方向，聚焦AI应用交付、智能化服务管理、数字化项目实施与运营优化等实际岗位场景</div>
            </div>

            <div class="partners section" id="partners">
                <div class="title">认证体系</div>
                <div class="disc" style="margin-bottom: 16px;">智先生AI培训认证体系分为两大方向:</div>
                <div class="ai-certification">
                    <div v-for="(direction, directionIndex) in certificationDirections" :key="direction.code"
                        class="direction-card" :style="direction.styleVars">
                        <div class="direction-header">
                            <div class="direction-header-copy">
                                <div class="direction-title-row">
                                    <div class="direction-title">
                                        <span class="direction-title-index">{{ directionIndex + 1
                                            }}、</span>{{ direction.title }}
                                    </div>
                                </div>
                                <div class="direction-code">{{ direction.code }}</div>
                                <div class="direction-description">{{ direction.description }}</div>
                            </div>
                        </div>
                        <template v-if="direction.showCapabilities">
                            <div class="direction-section-title">核心能力</div>
                            <div class="direction-capability-list">
                                <div v-for="capability in direction.capabilities" :key="capability.text"
                                    class="direction-capability-item">
                                    <div class="direction-capability-icon-wrap">
                                        <img class="direction-capability-svg" :src="capability.iconSrc"
                                            :alt="capability.text" />
                                    </div>
                                    <span class="direction-capability-text">{{ capability.text }}</span>
                                </div>
                            </div>
                        </template>
                        <div class="direction-section-title">{{ direction.levelTitle }}</div>
                        <div style="position: relative;">
                            <img v-if="!isMobile" class="introImg" src="../../assets/training/intro.png" alt="intro" />
                            <div style="display: flex;flex-direction: column;">
                                <div class="introLayout1">
                                    <div class="introTitle">{{ direction.levels[0].name }}<div class="introHonor">{{
                                        direction.levels[0].code }}
                                        </div>
                                    </div>
                                    <div class="introDescription">{{ direction.levels[0].description }}</div>
                                </div>
                                <div class="introLayout2">
                                    <div class="introTitle">{{ direction.levels[1].name }}<div class="introHonor"
                                            style="color: #1CB3B8;">{{
                                                direction.levels[1].code }}</div>
                                    </div>
                                    <div class="introDescription">{{ direction.levels[1].description }}</div>
                                </div>
                                <div class="introLayout3">
                                    <div class="introTitle">{{ direction.levels[2].name }}<div class="introHonor"
                                            style="color: #387EED;">{{
                                                direction.levels[2].code }}</div>
                                    </div>
                                    <div class="introDescription">{{ direction.levels[2].description }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" id="audience">
                <div class="title">面向人群</div>
                <div class="localRow" v-if="!isMobile">
                    <div v-for="audience in audienceCards" :key="audience.text" class="card1">
                        <img class="audience-icon" :src="audience.iconSrc" :alt="audience.text" />
                        <div class="car_obvious1">{{ audience.text }}</div>
                    </div>
                </div>
                <div class="localRow-mobile" v-if="isMobile">
                    <div v-for="audience in audienceCards" :key="audience.text" class="card1-mobile">
                        <img style="width: 24px;height: 24px;" :src="audience.iconSrc" :alt="audience.text" />
                        <div class="car_obvious1-mobile">{{ audience.text }}</div>
                    </div>
                </div>
            </div>
            <div class="section" id="value">
                <div class="title">认证价值</div>
                <div class="value-grid">
                    <div v-for="value in certificationValues" :key="value.title" class="value-card">
                        <img v-if="isMobile" style="width: 40px;height: 40px;" :src="value.iconSrc" />
                        <img v-else style="width: 64px;height: 64px;" :src="value.iconSrc" />
                        <div class="value-card-title">{{ value.title }}</div>
                        <div class="value-card-description">{{ value.description }}</div>
                    </div>
                </div>
            </div>
            <div class="section" id="process">
                <div class="title">认证流程</div>
                <div class="process-flow">
                    <div v-for="(step, index) in certificationProcess" :key="step.title" class="process-step"
                        :class="{ 'is-last': index === certificationProcess.length - 1 }">
                        <div class="process-step-marker">
                            <div class="process-step-pill">{{ step.title }}</div>
                        </div>
                        <div class="process-step-body">{{ step.description }}</div>
                        <svg v-if="index != certificationProcess.length - 1" class="process-step-icon" width="11"
                            height="16" viewBox="0 0 11 16" fill="none">
                            <path
                                d="M10.3125 6.33931L2.41 0.308057C2.18761 0.138345 1.9222 0.0342025 1.64374 0.00739377C1.36529 -0.019414 1.08488 0.0321807 0.834203 0.15635C0.583525 0.280519 0.372565 0.472313 0.225154 0.710068C0.0777425 0.947822 -0.000245449 1.22206 -1.52995e-08 1.50181L5.11887e-07 13.5624C-1.16899e-05 13.8421 0.0781456 14.1161 0.225649 14.3537C0.373153 14.5913 0.58413 14.7829 0.834764 14.9069C1.0854 15.0309 1.36571 15.0824 1.64406 15.0556C1.9224 15.0287 2.1877 14.9246 2.41 14.7549L10.3125 8.72368C10.4958 8.58369 10.6444 8.40329 10.7467 8.19652C10.849 7.98975 10.9022 7.76218 10.9022 7.5315C10.9022 7.30081 10.849 7.07324 10.7467 6.86647C10.6444 6.6597 10.4958 6.4793 10.3125 6.33931Z"
                                fill="#1CB3B8" />
                        </svg>
                    </div>
                </div>
            </div>
            <!-- <div id="content" style="margin-top: 80px;">
        <h1>认证内容</h1>
        <div class="localRow" style="margin-top: 32px;">
          <div class="card4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
              <path d="M31.0112 1.13477H31.9965C33.4815 1.17788 34.9736 1.30722 36.4304 1.63776C37.4087 1.87488 38.3659 2.19823 39.3371 2.47847C45.4672 4.31797 51.5973 6.15748 57.7273 8.00417C58.6634 8.29877 59.6135 8.70117 60.2962 9.44128C60.6903 9.85804 60.9437 10.4113 61 10.9934V11.3886C60.9367 11.9706 60.6833 12.5167 60.2821 12.9335C59.6206 13.6448 58.7056 14.04 57.8048 14.3275C54.5039 15.3263 51.1961 16.3107 47.8883 17.3095V22.7202C47.9375 24.725 47.6912 26.7513 47.0648 28.6627C45.8543 32.4279 43.2784 35.7117 39.9424 37.7524C38.021 38.9308 35.8674 39.6997 33.6434 39.9943C30.9338 40.3536 28.1327 40.023 25.5849 39.0099C21.9744 37.5943 18.9059 34.8207 17.076 31.3429C15.8092 28.9573 15.1335 26.2555 15.1194 23.5465V17.3095L11.5301 16.2316V22.3681C11.5371 22.8208 11.3682 23.2807 11.0445 23.5968C10.6644 23.9992 10.0803 24.1717 9.54537 24.0567C8.8275 23.9202 8.24334 23.2376 8.24334 22.4903V15.2544C7.25803 14.9526 6.27271 14.6652 5.28739 14.3634C4.56952 14.1406 3.85869 13.8532 3.23934 13.4005C2.79595 13.0772 2.40886 12.646 2.19069 12.1287C1.95139 11.5682 1.93732 10.9071 2.14846 10.3323C2.35256 9.77181 2.75372 9.31194 3.21823 8.97422C3.95018 8.4353 4.80881 8.1335 5.66744 7.88201C12.2831 5.89879 18.8988 3.90839 25.5145 1.92518C27.2951 1.37189 29.1602 1.18506 31.0112 1.13477ZM9.46795 26.2914C9.98876 26.1621 10.58 26.2914 10.9811 26.6723C11.2767 26.9669 11.5582 27.2615 11.8538 27.5561C12.1846 27.8866 12.3676 28.3609 12.3394 28.8351C12.3324 29.3237 12.072 29.7764 11.7201 30.0926C11.3541 30.4303 11.0585 30.8614 10.6151 31.0914C10.0591 31.3788 9.3483 31.2998 8.86268 30.9046C8.57413 30.6531 8.32076 30.3585 8.04628 30.0926C7.8281 29.877 7.624 29.6327 7.52547 29.3381C7.31433 28.7633 7.44101 28.0734 7.84922 27.6279C8.10258 27.3549 8.37003 27.0962 8.62339 26.8303C8.84861 26.5788 9.13717 26.3777 9.46795 26.2914Z" fill="#1CB3B8" />
              <path d="M16.9233 37.1886C17.3931 37.0716 17.9191 37.161 18.3118 37.4501C20.1 38.751 22.0636 39.8179 24.1464 40.5819C26.685 41.518 29.3989 41.9998 32.1128 41.9791C36.3976 41.9722 40.6473 40.692 44.2448 38.4206C44.7427 38.1109 45.2266 37.7736 45.7105 37.4295C46.1242 37.1404 46.6712 37.0578 47.1551 37.2092C47.5198 37.3125 47.8003 37.5809 48.1018 37.7943C51.9939 40.7471 55.0725 44.691 57.0991 49.0824C58.7191 52.5789 59.6868 56.3646 59.9814 60.1984C60.0094 60.4737 60.0164 60.7559 59.9253 61.0244C59.7289 61.6438 59.1188 62.1119 58.4596 62.1325H5.76606C5.45049 62.1463 5.12791 62.0981 4.85441 61.9398C4.30041 61.6576 3.94977 61.0313 4.00587 60.4256C4.27236 56.516 5.24712 52.6478 6.90212 49.0824C8.93581 44.6841 12.0214 40.7333 15.9275 37.7736C16.229 37.5465 16.5306 37.2712 16.9233 37.1886ZM28.34 50.6586C27.6878 50.81 27.1689 51.3813 27.1058 52.0352C27.0146 52.7166 27.4424 53.4049 28.0805 53.6733C28.4943 53.8592 28.9641 53.7972 29.4059 53.811H35.2615C35.8155 53.811 36.3485 53.5081 36.636 53.047C36.9797 52.5239 36.9586 51.808 36.5869 51.2987C36.2924 50.8788 35.7875 50.6104 35.2615 50.6104H29.0623C28.8239 50.6104 28.5784 50.5966 28.34 50.6586Z" fill="#386FC6" />
            </svg>
            <div class="car_obvious">IT 服务领航专家认证</div>
            <div class="car_declare4">聚焦 IT 服务管理高端领域，培养具备战略规划与全局把控能力的领航型专家，助力企业 IT 服务体系的顶层设计与高效引领。</div>
          </div>

          <div class="card4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
              <path d="M47.4526 37.7422L60.7326 53.2356C62.0852 54.7931 62.3721 57.0065 61.5114 58.8919C60.6506 60.7773 58.7652 61.966 56.7158 61.966H39.173V47.1284C39.173 46.5546 38.7222 46.1037 38.1483 46.1037H34.8693C34.2955 46.1037 33.8446 46.5546 33.8446 47.1284V61.966H16.2608C14.2114 61.966 12.326 60.7773 11.4653 58.8919C10.6045 57.0065 10.8914 54.7931 12.244 53.2356L25.5241 37.7422C28.8441 39.7506 32.615 40.8163 36.4678 40.8163C40.4846 40.7753 44.2555 39.6686 47.4526 37.7422Z" fill="#1CB3B8" />
              <path d="M18.8431 19.6638C18.8431 21.9837 19.299 24.2809 20.1847 26.4242C21.0705 28.5675 22.3687 30.515 24.0053 32.1554C25.6419 33.7958 27.5849 35.097 29.7232 35.9848C31.8615 36.8726 34.1534 37.3296 36.4679 37.3296C38.7824 37.3296 41.0743 36.8726 43.2126 35.9848C45.3509 35.097 47.2939 33.7958 48.9305 32.1554C50.5671 30.515 51.8653 28.5675 52.7511 26.4242C53.6368 24.2809 54.0927 21.9837 54.0927 19.6638C54.0927 14.9785 52.2358 10.4852 48.9305 7.17223C45.6252 3.85926 41.1423 1.99805 36.4679 1.99805C31.7935 1.99805 27.3106 3.85926 24.0053 7.17223C20.7 10.4852 18.8431 14.9785 18.8431 19.6638Z" fill="#1CB3B8" />
              <path d="M20.0318 40.6102V32.4126C20.0318 31.2239 19.0481 30.2402 17.8595 30.2402H4.16955C2.9809 30.2402 1.99719 31.2239 1.99719 32.4126V59.7925C1.99719 60.9811 2.9809 61.9648 4.16955 61.9648H11.0145C10.0718 61.35 9.29303 60.4483 8.80117 59.3826C7.77648 57.1282 8.14537 54.505 9.74389 52.6196L20.0318 40.6102ZM5.07128 36.0195C5.07128 35.1178 5.80906 34.38 6.71079 34.38H14.9084C15.8101 34.38 16.5479 35.1178 16.5479 36.0195C16.5479 36.9212 15.8101 37.659 14.9084 37.659H6.71079C5.80906 37.7 5.07128 36.9622 5.07128 36.0195ZM6.71079 43.1514C5.80906 43.1514 5.07128 42.4136 5.07128 41.5119C5.07128 40.6102 5.80906 39.8724 6.71079 39.8724H14.9084C15.8101 39.8724 16.5479 40.6102 16.5479 41.5119C16.5479 42.4136 15.8101 43.1514 14.9084 43.1514H6.71079Z" fill="#386FC6" />
            </svg>
            <div class="car_obvious">IT 服务运营师认证</div>
            <div class="car_declare4">专注于 IT 服务运营全流程，打造精通运营管理、保障 IT 服务高效稳定运转的专业运营人才。</div>
          </div>
          <div class="card4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
              <path d="M32.2189 34.7452C41.6456 34.7452 48.9381 24.66 48.9381 16.3537C48.8892 13.5854 48.0717 10.8819 46.5726 8.5312C45.0735 6.18046 42.949 4.27052 40.4254 3.00484C37.7909 1.6872 34.873 1 31.9127 1C28.9523 1 26.0344 1.6872 23.4 3.00484C20.9042 4.27581 18.8169 6.19511 17.3687 8.55078C15.9205 10.9065 15.1678 13.6068 15.1935 16.3537C15.1935 24.66 22.7923 34.7452 32.2189 34.7452Z" fill="#386FC6" />
              <path d="M5.00859 50.9226C5.15542 48.8572 5.83661 46.8654 6.98534 45.1427C8.13408 43.42 9.7109 42.0255 11.5611 41.0959L18.3844 38.0882L23.5705 54.1924C23.5705 54.1924 23.8455 55.5588 26.299 55.5588C28.7524 55.5588 28.7567 54.1924 28.7567 54.1924V41.0873C28.7715 40.6494 28.8778 40.2195 29.0687 39.8251C29.2596 39.4308 29.5309 39.0807 29.8652 38.7975C30.1994 38.5142 30.5892 38.304 31.0095 38.1804C31.4299 38.0567 31.8714 38.0224 32.3058 38.0796C32.7218 38.0465 33.1401 38.0996 33.5346 38.2355C33.9291 38.3714 34.2914 38.5873 34.5987 38.8696C34.906 39.1519 35.1517 39.4945 35.3206 39.8761C35.4894 40.2577 35.5777 40.6701 35.5799 41.0873V54.1924C35.8871 54.7111 36.3288 55.1371 36.8583 55.4253C37.3877 55.7135 37.9853 55.8531 38.5877 55.8295C39.679 55.8295 40.7704 55.2838 40.7704 54.1924L45.6859 38.0882L52.5091 41.0959C54.3593 42.0255 55.9362 43.42 57.0849 45.1427C58.2336 46.8654 58.9148 48.8572 59.0616 50.9226V55.0088C59.0491 55.9331 58.8492 56.8453 58.474 57.6902C58.0988 58.5351 57.5562 59.2951 56.8789 59.9243C56.1828 60.5686 55.3664 61.0692 54.4764 61.3973C53.5865 61.7255 52.6405 61.8746 51.6927 61.8363H12.3775C10.4858 61.7856 8.66328 61.1137 7.19134 59.9243C6.5125 59.2958 5.96827 58.5361 5.5916 57.6912C5.21494 56.8463 5.01367 55.9338 5 55.0088L5.00859 50.9226Z" fill="#1CB3B8" />
            </svg>
            <div class="car_obvious">IT 服务应用专员认证</div>
            <div class="car_declare4">面向 IT 服务应用层面，培养熟练掌握 IT 服务应用技能、能高效支撑业务应用需求的专业专员。</div>
          </div>
        </div>
      </div> -->
            <!-- <div class="localRow">
          <div class="card2" :style="{'border-color': isMobile ? '#fff' : '#d9dbdf','padding': isMobile ? '0px' : '16px'}">
            <img src="../../assets/train/credential-03.png" alt="Logo" />
            <div class="car_obvious2">可独立承接大型运营商级的项目开局与维护。</div>
          </div>
          <div class="card2" :style="{'border-color': isMobile ? '#fff' : '#d9dbdf','padding': isMobile ? '0px' : '16px'}">
            <img src="../../assets/train/credential-04.png" alt="Logo" />
            <div class="car_obvious2">可深入了解网络安全及应用交付技术，并具备相关产品实施与维护的能力。</div>
          </div>
          <div class="card2" :style="{'border-color': isMobile ? '#fff' : '#d9dbdf','padding': isMobile ? '0px' : '16px'}">
            <img src="../../assets/train/credential-02.png" alt="Logo" />
            <div class="car_obvious2">可初步了解网络安全通用技术，并具备相关产品实施与维护的能力。</div>
          </div>
        </div>
      </div> -->
            <div class="section" id="query" style="margin-bottom: 0;">
                <div class="title">证书查询</div>
                <div class="disc">
                    请输入姓名与证书编号，查询证书真实性及认证信息。<br />
                    证书信息以智先生官网查询结果为准。<br />
                    本认证为智先生自主培训认证，用于证明学员完成相应方向的课程学习、实训任务与结业考核，不属于国家职业资格证书或人力资源社会保障部门备案的职业技能等级证书。
                </div>
                <div v-if="!isMobile" class="localRow" style="align-items: center;flex-wrap: nowrap;">
                    <svg style="margin-right: -13px;" xmlns="http://www.w3.org/2000/svg" width="6" height="6"
                        viewBox="0 0 6 6" fill="none">
                        <circle cx="3" cy="3" r="3" fill="#FF6060" />
                    </svg>
                    <form-input style="width: 320px;" :data.sync="form.name" label="姓名"></form-input>
                    <svg style="margin-right: -13px;" xmlns="http://www.w3.org/2000/svg" width="6" height="6"
                        viewBox="0 0 6 6" fill="none">
                        <circle cx="3" cy="3" r="3" fill="#FF6060" />
                    </svg>
                    <form-input :data.sync="form.certificate" label="证书编号"></form-input>
                    <div @click="submit" style="width: 320px;display: flex;">
                        <read-more class="read-more" width="320px" text="查询"></read-more>
                    </div>
                </div>
                <div v-else style="align-items: center;display: flex;flex-direction: column;">
                    <div style="align-items: center;display: flex;flex-direction: row;margin-top: 16px;width: 100%;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="#FF6060" />
                        </svg>
                        <form-input style="width: 100%;" :data.sync="form.name" label="姓名"></form-input>
                    </div>
                    <div style="align-items: center;display: flex;flex-direction: row;margin-top: 16px;width: 100%;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="#FF6060" />
                        </svg>
                        <form-input style="width: 100%;" :data.sync="form.certificate" label="证书编号"></form-input>
                    </div>
                    <div @click="submit" style="width: 100%;margin-top: 16px;">
                        <read-more class="read-more" width="100%" text="查询"></read-more>
                    </div>
                </div>
            </div>
            <div class="error-container" v-if="errorMessage">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z"
                        stroke="#FF6060" stroke-width="2" stroke-linejoin="round" />
                    <path d="M15.5 9V9.5" stroke="#FF6060" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M8.5 9V9.5" stroke="#FF6060" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M15.5 15.5C15.5 15.5 14.5 13.5 12 13.5C9.5 13.5 8.5 15.5 8.5 15.5" stroke="#FF6060"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="error">{{ errorMessage }}</div>
            </div>
            <!-- <div class="section" id="agency">
                <div class="title">考试授权机构</div>
                <div class="localRow" style="align-items: center;">
                    <div class="card3">
                        <img style="height:88px;width:378px;" src="../../assets/training/p1.png" alt="p1" />
                    </div>
                    <div class="card3">
                        <img style="height:138px;width:311px;" src="../../assets/training/p2.png" alt="p2" />
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import TopBg from "../common/TopBg.vue";
import FormInput from "../common/form-input.vue";

export default {
    name: "TrainContent",
    components: { TopBg, FormInput },
    data() {
        return {
            topBg: require("../../assets/training/trainBg.png"),
            form: {
                name: '',
                certificate: '',
            },
            errorMessage: '',
            activeSection: '',
            showRow: false,
            isMobile: false,
            certificationDirections: [
                {
                    title: 'AI智能体应用交付工程师认证',
                    code: 'AI-FDE',
                    description: 'AI-FDE 面向 AI 智能体应用与行业场景落地，重点培养能够把 AI 产品能力交付到业务现场的复合型工程师。认证围绕需求调研、场景拆解、方案配置、智能体应用搭建、知识库配置、流程编排、测试验收、上线交付和持续优化等环节展开，强调从客户需求到业务落地的完整交付能力。通过 AI-FDE 方向培训认证，代表学员已完成相应等级的课程学习、案例实训与结业考核，具备参与 AI 应用项目交付、连接客户、业务、产品与技术团队的相关基础。',
                    showCapabilities: true,
                    capabilities: [
                        { text: '识别业务场景，拆解AI应用需求', iconSrc: require('../../assets/training/capabilities/capability-01.png') },
                        { text: '设计智能体任务流程与交互方式', iconSrc: require('../../assets/training/capabilities/capability-02.png') },
                        { text: '配置知识库、提示词、工作流与工具调用', iconSrc: require('../../assets/training/capabilities/capability-03.png') },
                        { text: '协同业务系统、数据资源与交付团队', iconSrc: require('../../assets/training/capabilities/capability-04.png') },
                        { text: '完成应用测试、效果评估与上线验收', iconSrc: require('../../assets/training/capabilities/capability-05.png') },
                        { text: '根据真实使用反馈持续优化应用效果', iconSrc: require('../../assets/training/capabilities/capability-06.png') },
                    ],
                    levelTitle: 'AI-FDE认证层级',
                    styleVars: {
                        '--direction-accent': '#1CB3B8',
                        '--direction-accent-soft': 'rgba(28, 179, 184, 0.12)',
                    },
                    levels: [
                        {
                            name: 'AI智能体应用交付高级工程师认证',
                            code: 'AI-FDE Senior Engineer',
                            description: '面向交付骨干和方案负责人，聚焦复杂场景方案设计、多智能体协同、业务系统集成、交付质量管控、项目复盘与持续优化能力。',
                        },
                        {
                            name: 'AI智能体应用交付工程师认证',
                            code: 'AI-FDE Engineer',
                            description: '面向项目交付人员，聚焦需求调研、场景拆解、智能体方案配置、知识库建设、工作流编排、测试验收和上线交付能力。',
                        },
                        {
                            name: 'AI智能体应用交付初级工程师认证',
                            code: 'AI-FDE Junior Engineer',
                            description: '面向入门人员，聚焦AI智能体基础认知、业务场景识别、知识库与提示词基础配置、简单应用搭建和交付辅助能力。',
                        },
                    ],
                },
                {
                    title: 'AI IT 服务管理认证',
                    code: 'AI-ITSM',
                    description: 'AI-ITSM 面向 AI 时代的信息化管理、IT 服务、智能运维和数字化支撑场景，培养既理解 IT 服务管理体系，又能够运用 AI 工具提升服务效率的复合型人才。该方向聚焦 IT 服务流程管理、运维支持、跨团队协同、风险与成本管控，以及 AI 在服务响应、问题分析、知识沉淀、流程优化中的应用能力，帮助组织推动 IT 服务管理向智能化升级。',
                    showCapabilities: false,
                    levelTitle: 'AI-ITSM认证层级',
                    styleVars: {
                        '--direction-accent': '#386FC6',
                        '--direction-accent-soft': 'rgba(56, 111, 198, 0.12)',
                    },
                    levels: [
                        {
                            name: 'AI IT 服务管理高级工程师认证',
                            code: 'AI-ITSM Senior Engineer',
                            description: '面向管理与架构人员，聚焦企业级IT服务管理体系建设、服务战略规划、技术架构优化、复杂运维问题治理，以及AI驱动的服务管理体系升级。',
                        },
                        {
                            name: 'AI IT 服务管理工程师认证',
                            code: 'AI-ITSM Engineer',
                            description: '面向项目与服务骨干，聚焦IT项目全周期推进、服务流程优化、跨团队协同、风险与成本管控，以及AI辅助运维和知识管理能力。',
                        },
                        {
                            name: 'AI IT服务管理初级工程师认证',
                            code: 'AI-ITSM Junior Engineer',
                            description: '面向入门人员，聚焦IT服务流程认知、基础运维辅助、常见问题响应与AI工具基础使用能力。',
                        },
                    ],
                },
            ],
            audienceCards: [
                { iconSrc: require('../../assets/training/audience/audience-01.png'), text: '医疗机构信息部门、数据中心、运营管理相关人员' },
                { iconSrc: require('../../assets/training/audience/audience-02.png'), text: '政企数字化、信息化、智能化项目建设人员' },
                { iconSrc: require('../../assets/training/audience/audience-03.png'), text: 'AI产品、售前、解决方案、项目交付与实施人员' },
                { iconSrc: require('../../assets/training/audience/audience-04.png'), text: 'IT服务管理、运维管理、系统集成与技术支持人员' },
                { iconSrc: require('../../assets/training/audience/audience-05.png'), text: '希望转向AI应用建设、智能体交付方向的从业者' },
                { iconSrc: require('../../assets/training/audience/audience-06.png'), text: '需要为团队建立AI应用落地培训体系的管理者' },
            ],
            certificationValues: [
                {
                    kind: 'individual',
                    iconSrc: require('../../assets/training/certification/certification-01.png'),
                    title: '对个人',
                    description: '建立AI应用交付的系统化学习框架，提升项目实施、客户沟通、配置交付和持续优化能力，获得可查询、可验证的培训认证记录。',
                },
                {
                    kind: 'organization',
                    iconSrc: require('../../assets/training/certification/certification-02.png'),
                    title: '对组织',
                    description: '建立AI应用落地所需的人才培养路径，提升智能体项目从试点到上线的交付效率，促进业务、技术、运维和管理团队协同。',
                },
            ],
            certificationProcess: [
                {
                    title: '报名咨询',
                    description: '确认学习目标、岗位背景与适合的认证方向。',
                },
                {
                    title: '课程学习',
                    description: '完成AI-FDE或AI-ITSM相应等级方向的系统课程学习。',
                },
                {
                    title: '案例实训',
                    description: '围绕真实业务场景完成智能体配置、方案设计与交付演练。',
                },
                {
                    title: '培训考核',
                    description: '通过培训考核，验证关键知识、方法和实操流程掌握情况。',
                },
                {
                    title: '证书颁发',
                    description: '考核通过后获得智先生AI培训认证证书，证书支持官网查询验证。',
                },
            ],
        };
    },
    watch: {
        $route() {
            this.scrollToAnchor();
        },

    },
    created() {
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    },
    mounted() {
        // 判断是否为移动设备
        const isMobile = window.innerWidth < 1000;
        this.isMobile = isMobile;
        this.scrollToAnchor();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
    },
    methods: {
        scrollToAnchor() {
            const hash = this.$route.hash;
            if (hash) {
                const targetElement = document.querySelector(hash);
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: "smooth" });
                }
            }
        },
        onScroll() {
            const ids = ['partners', 'audience', 'value', 'process', 'content', 'query', 'agency'];
            const scrollY = window.scrollY || window.pageYOffset || 0;
            let current = '';
            ids.forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    const offset = el.offsetTop;
                    if (scrollY + 150 >= offset) {
                        current = id;
                    }
                }
            });
            this.activeSection = current;
            const partnersEl = document.getElementById('partners');
            this.showRow = partnersEl ? (scrollY + 150 >= partnersEl.offsetTop) : false;
        },
        scrollToSection(id) {
            const el = document.getElementById(id);
            if (el) {
                console.log('scrollToSection', el);
                const offset = 150;
                const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top, behavior: 'smooth' });
                // el.scrollIntoView({ behavior: 'smooth' });
            }
        },
        submit() {
            if (this.form.name === '') {
                this.errorMessage = '请输入姓名';
                return;
            } else if (this.form.certificate === '') {
                this.errorMessage = '请输入证书编号';
                return;
            }
            this.errorMessage = '很抱歉，未查到证书信息，请检查您的姓名和证书编号是否正确。';
        },

    },
};
</script>

<style scoped>
.overview {
    font-family: PingFang SC;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0%;
    text-align: justify;
    letter-spacing: -0.02em;
}

.description {
    color: #50627f;
    text-align: justify;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 170%;
    letter-spacing: -0.16px;
}

.error-container {
    display: flex;
    flex-direction: row;
    min-height: 48px;
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 32px;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    background: rgba(255, 96, 96, 0.1);
}

.error {
    overflow: hidden;
    color: #ff6060;
    text-overflow: ellipsis;
    margin-left: 8px;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

h1 {
    color: #1f2329;
    text-align: left;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 32px;
}

h1 span {
    color: #1cb3b8;
    font-weight: 600;
}

.localRow {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-between;
    justify-content: center;
    align-items: center;
}

.nav-row {
    position: fixed;
    top: 66px;
    padding: 8px;
    z-index: 10;
    width: 1328px;
    height: 54px;
    gap: 8px;
    justify-self: center;
    border-radius: 8px;
    border: 1px solid #d9dbdf;
    background: #fff;
    box-shadow: 0 4px 16px 0 rgba(56, 111, 198, 0.06);
}

.nav-item {
    color: #50627f;
    font-size: 16px;
    cursor: pointer;
    border-radius: 8px;
    background: #ecf1fa;
    text-align: justify;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    flex: 1;
    line-height: 38px;
    align-self: center;
    text-align: center;
}

.nav-item.active {
    color: #fff;
    background: #1cb3b8;
    font-weight: 600;
}

.card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #d9dbdf;
    background: #fff;
    height: 264px;
    width: 320px;
}

.card1 {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 16px;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #d9dbdf;
    background: #fff;
    height: 88px;
}

.audience-icon {
    width: 48px;
    height: 48px;
}

.localRow-mobile {
    display: flex;
    flex-direction: column;
    /* flex-wrap: wrap; */
    gap: 16px;
    /* justify-content: space-between; */
    /* justify-content: center; */
    /* align-items: center; */
}

.card1-mobile {
    flex: 1;
    padding: 16px;
    /* align-items: center; */
    border-radius: 8px;
    border: 1px solid #d9dbdf;
    background: #fff;
    /* height: 86px; */
}

.car_obvious1-mobile {
    color: #50627F;
    text-align: justify;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;


}

.value-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.value-card {
    min-height: 270px;
    padding: 32px;
    border-radius: 8px;
    border: 1px solid #d9dbdf;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.value-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 30px rgba(56, 111, 198, 0.12);
}

.value-icon-individual {
    background: linear-gradient(135deg, rgba(28, 179, 184, 0.18) 0%, rgba(56, 111, 198, 0.16) 100%);
}

.value-icon-organization {
    background: linear-gradient(135deg, rgba(56, 111, 198, 0.18) 0%, rgba(28, 179, 184, 0.12) 100%);
}

.value-card-title {
    margin-top: 32px;
    color: #1f2329;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-weight: 500;
    line-height: normal;
}

.value-card-description {
    margin-top: 16px;
    color: #50627f;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 400;
    line-height: 170%;
}

.process-flow {
    position: relative;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 30px;
    margin-top: 40px;
}

.process-flow::before {
    content: "";
    position: absolute;
    left: 96px;
    right: 96px;
    top: 28px;
    height: 4px;
    background: #d9dbdf;
}

.process-step {
    position: relative;
    display: flex;
    flex-direction: column;
    /* gap: 16px; */
}

.process-step-icon {
    position: absolute;
    right: -20px;
    top: 22.5px;
}

.process-step-marker {
    z-index: 1;
    /* position: relative;
    z-index: 1;
    display: flex;
    justify-content: center; */
}

.process-step-pill {
    min-height: 50px;
    padding: 0 24px;
    border-radius: 30px;
    border: 1px solid #d9dbdf;
    background: #fff;
    box-shadow: 0 4px 10px 0 rgba(15, 33, 61, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1f2329;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;

}

.process-step-body {
    min-height: 162px;
    padding: 24px 16px;
    border-radius: 8px;
    background: #eef1f8;
    color: #50627f;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -24px;
}

.card2 {
    border-radius: 8px;
    padding: 16px;
    height: 378px;
    border: 1px solid #d9dbdf;
    background: #fff;
    display: flex;
    flex-direction: column;
    width: 432px;
}

.card3 {
    height: 222px;
    border-radius: 8px;
    flex: 1;
    background: #eef1f8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.card4 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 8px;
    padding-top: 32px;
    border: 1px solid #d9dbdf;
    background: #fff;
    height: 291px;
    width: 432px;
}

.car_obvious {
    color: #1f2329;
    text-align: center;
    margin-top: 32px;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.car_obvious1 {
    color: #50627f;
    font-family: 'PingFang SC';
    font-size: 20px;
    /* font-style: normal;
    font-weight: 500; */
    margin-left: 16px;
    /* line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;     */
    min-width: 300px;
}

.car_obvious2 {
    color: #50627f;
    text-align: justify;
    margin-top: 16px;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 170%;
}

.car_declare {
    color: #50627f;
    margin-top: 16px;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 16px;
    padding-left: 30px;
    padding-right: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 170%;
    letter-spacing: -1.12px;
}

.car_declare4 {
    color: #50627f;
    margin-top: 16px;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 16px;
    padding-left: 30px;
    padding-right: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 170%;
}

/* .info {
  border-radius: 8px 0px 0px 8px;
  border: 1px solid #d9dbdf;
  background: linear-gradient(8deg, #f8faff 0%, #d1d9ec 100%);
  padding: 32px;
  margin-bottom: 80px;
}

.info p {
  color: #50627f;
  text-align: justify;
  font-family: 'PingFang SC';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 170%; 
  letter-spacing: -0.72px;
}

.info p:first-child {
  margin-bottom: 14px;
} */

.partners {
    margin-bottom: 80px;
    position: relative;
}

.history h1,
.partners h1 {
    margin-bottom: 32px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.6s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.introLayout1 {
    min-height: 132px;
    /* border-radius: 8px 0 0 8px;
  border: 6px solid transparent;
  background:
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(272deg, #1cb3b8 0.61%, #386fc6 100%) border-box; */
    display: flex;
    flex-direction: column;
    padding: 16px;
    background-image: url('@/assets/training/introLayout_back1.png');
    background-size: 80% 100%;
    background-repeat: no-repeat;
}

.introLayout2 {
    min-height: 132px;
    /* border-radius: 8px 0 0 8px;
  border: 1px solid transparent; */
    margin-top: 32px;
    background-image: url('@/assets/training/introLayout_back2.png');
    background-size: 70% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    padding: 16px;
}

.introLayout3 {
    min-height: 132px;
    margin-top: 32px;
    /* border-radius: 8px 0 0 8px;
  border: 1px solid transparent; */
    background-image: url('@/assets/training/introLayout_back3.png');
    background-size: 60% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    padding: 16px;
}

.introTitle {
    color: #1f2329;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
}



.introHonor {
    color: #16b9ff;
    font-family: 'PingFang SC';
    font-size: 20px;
    font-style: normal;
    height: min-content;
    font-weight: 500;
    line-height: normal;
    margin-left: 8px;
}

@media screen and (max-width: 1000px) {
    .introTitle {
        font-size: 18px;
        display: block;
    }

    .introHonor {
        /* color: #16b9ff;
    font-family: 'PingFang SC';
    font-size: 20px;
    font-style: normal;
    height: min-content;
    font-weight: 500;
    line-height: normal; */
        margin-left: 0;
    }
}

.subTitle {
    color: #50627f;
    margin-top: 4px;
    font-family: 'PingFang SC';
    font-size: 12px;
    width: min-content;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
}

.introDescription {
    color: #50627f;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    margin-top: 12px;
    font-weight: 400;
    line-height: 170%;
    max-width: 720px;
    text-align: left;
}

.introImg {
    width: 433px;
    height: 494px;
    position: absolute;
    right: 0px;
    top: 0;
}

.introImg2 {
    margin-top: 10px;
    max-width: 100%;
    /* 宽超容器时等比缩小 */
    height: auto;
    /* 高跟随比例 */
    display: block;
}

.ai-certification {
    display: flex;
    flex-direction: column;
    gap: 32px;
    /* margin-top: 40px; */
}

.direction-card {
    border-radius: 8px;
    border: 1px solid #d9dbdf;
    background: #eef1f8;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.direction-header {
    display: flex;
    align-items: flex-start;
}

.direction-header-copy {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
}

.direction-title-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 16px;
}

.direction-title {
    color: #1f2329;
    font-family: 'PingFang SC';
    font-size: 32px;
    font-weight: 600;
    line-height: 140%;
}

.direction-title-index {
    margin-right: 4px;
}

.direction-code {
    color: #1d2129;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-weight: 500;
    line-height: 170%;
    letter-spacing: -0.28px;
    margin-top: 2px;
}

.direction-description {
    color: #50627f;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 400;
    line-height: 170%;
    text-align: justify;
}

.direction-section-title {
    color: #1f2329;
    font-family: 'PingFang SC';
    font-size: 22px;
    font-weight: 600;
    line-height: 140%;
}

.direction-capability-list {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 14px;
}

.direction-capability-item {
    min-height: 179px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    padding: 32px 16px 0;
    border-radius: 8px;
    border: 1px solid #d9dbdf;
    background: #fff;
}

.direction-capability-icon-wrap {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
}

.direction-capability-svg {
    width: 50px;
    height: 50px;
    display: block;
}

.direction-capability-text {
    width: 167px;
    color: #50627f;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 400;
    line-height: 170%;
    letter-spacing: -0.16px;
}

.direction-level-list {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
}

.direction-level-card {
    min-height: 216px;
    padding: 24px;
    border-radius: 8px;
    border: 1px solid rgba(217, 219, 223, 0.9);
    background: #fff;
    display: flex;
    flex-direction: column;
}

.direction-level-name {
    color: #1f2329;
    font-family: 'PingFang SC';
    font-size: 20px;
    font-weight: 600;
    line-height: 150%;
}

.direction-level-code {
    color: var(--direction-accent);
    font-family: 'PingFang SC';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    margin-top: 8px;
}

.direction-level-description {
    color: #50627f;
    font-family: 'PingFang SC';
    font-size: 15px;
    font-weight: 400;
    line-height: 170%;
    margin-top: 16px;
    text-align: justify;
}

@media screen and (max-width: 1000px) {
    .ai-certification {
        /* margin-top: 24px; */
        gap: 20px;
    }

    .direction-card {
        padding: 20px 16px;
        gap: 16px;
    }

    .direction-title {
        font-size: 22px;
    }

    .direction-code {
        font-size: 18px;
        line-height: 150%;
        letter-spacing: 0;
        margin-top: 0;
    }

    .direction-description,
    .direction-capability-item,
    .direction-level-description {
        font-size: 14px;
    }

    .direction-section-title {
        font-size: 18px;
    }

    .direction-capability-list,
    .direction-level-list {
        grid-template-columns: minmax(0, 1fr);
    }

    .direction-capability-item {
        min-height: 56px;
        flex-direction: row;
        justify-content: flex-start;
        gap: 8px;
        padding: 16px;
        border: none;
    }
    .direction-title-row {
    /* display: flex;
    align-items: flex-start;
    width: 100%; */
    margin-bottom: 4px;
}

    .direction-capability-icon-wrap,
    .direction-capability-svg {
        width: 24px;
        height: 24px;
    }

    .direction-capability-text {
        width: auto;
        text-align: left;
        font-size: 14px;
        line-height: 170%;
        letter-spacing: 0;
    }

    .direction-level-card {
        min-height: auto;
        padding: 20px 16px;
    }

    .direction-level-name {
        font-size: 18px;
    }

    .value-grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .value-card {
        min-height: auto;
        padding: 16px;
        align-items: flex-start;
        text-align: left;
    }

    .value-icon {
        width: 40px;
        height: 40px;
    }

    .value-card-title {
        margin-top: 16px;
        font-size: 16px;
    }

    .value-card-description {
        text-align: left;
        font-size: 14px;
    }

    .process-flow {
        display: flex;
        flex-direction: column;
        gap: 40px;
        margin-top: 24px;
    }

    .process-flow::before {
        display: none;
    }

    .process-step {
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
    }

    .process-step-icon {
        position: absolute;
        left: 39px;
        top: 48px;
        transform: rotate(90deg);
        z-index: 1;
    }

    .process-step-marker {
        flex-shrink: 0;
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: center;
    }

    .process-step-marker::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 31px;
        bottom: -55px;
        width: 1px;
        background: #d9dbdf;
        transform: translateX(-50%);
    }

    .process-step.is-last .process-step-marker::after {
        display: none;
    }

    .process-step-pill {
        min-height: 32px;
        padding: 0 12px;
        font-size: 16px;
    }

    .process-step-body {
        min-height: auto;
        padding: 12px;
        text-align: left;
        justify-content: flex-start;
        font-size: 13px;
        flex: 1;
    }
}
</style>
